const apiUrl = process.env.REACT_APP_API_URL;

export const PostProjectesIdTasques = async (tasca: any, id_projecte: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id_projecte}/tasques`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(tasca)
        });

        if (response.ok) {
            // El backend devuelve 201 sin cuerpo, así que solo verificamos que sea exitoso
            return { success: true, status: response.status };
        } else {
            const errorText = await response.text();
            alert(errorText || 'Error al guardar la tarea');
            return { success: false, error: errorText };
        }

    } catch (error) {
        console.error('Error al guardar la tarea:', error);
        return { success: false, error };
    }
};
